import { DOMAIN_FRAGMENT } from 'features/inventory/api/fragments/domain'
import { Ability } from 'providers/casl/types/ability'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_DOMAIN = (
  ability: Ability,
): TypedDocumentNode<Data, { input: Variables }> => gql`
  ${DOMAIN_FRAGMENT({ ability })}
  ${ERROR_FRAGMENT}

  mutation createDomain($input: CreateDomainInput!) {
    createDomain(input: $input) {
      domain {
        ...DomainFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
